import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

import { layoutClasses } from "../../utils/classes";

import type { BoxProps } from "@mui/material/Box";
import type { Breakpoint } from "@mui/material/styles";

// ----------------------------------------------------------------------

type MainProps = BoxProps & {
  layoutQuery: Breakpoint;
};

export function Main({ sx, children, layoutQuery, ...other }: MainProps) {
  const theme = useTheme();

  return (
    <Box
      component="main"
      className={layoutClasses.main}
      sx={{
        display: "flex",
        flex: "1 1 auto",
        alignItems: "stretch",
        flexDirection: "column",
        width: "100%", // Ensures full width
        height: "100vh", // Ensures full height
        p: theme.spacing(0), // Remove extra padding
        [theme.breakpoints.up(layoutQuery)]: {
          justifyContent: "center",
          height: "100vh",
        },
        ...sx,
      }}
      {...other}
    >
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          bgcolor: theme.palette.background.default,
          width: "100%", // Ensures full width
          height: "100%", // Ensures full height
          overflow: "hidden",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
